import { render, staticRenderFns } from "./ChequeReturn.vue?vue&type=template&id=d2130a94&"
import script from "./ChequeReturn.vue?vue&type=script&lang=js&"
export * from "./ChequeReturn.vue?vue&type=script&lang=js&"
import style0 from "./ChequeReturn.vue?vue&type=style&index=0&id=d2130a94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports